import React from 'react';
import SkeletonLoader from './SkeletonLoader';
import PostCardSkeleton from './PostCardSkeleton';

const UpcomingPostsSkeleton = () => (
  <div className='mb-8'>
    <div className='h-5 skeleton rounded w-40 mb-4' />
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
      <PostCardSkeleton aspectRatio='9:16' />
      <PostCardSkeleton aspectRatio='1:1' />
      <PostCardSkeleton aspectRatio='9:16' />
      <PostCardSkeleton aspectRatio='9:16' />
    </div>
  </div>
);

export default UpcomingPostsSkeleton;
